import { CLIENT_BY_ID, RECURRENT_CLIENTS } from '../data/clientLoyalty';

/**
 * resolveClient — robust lookup that accepts a contract / message
 * payload and returns the matching RECURRENT_CLIENTS entry.
 *
 * Resolution order :
 *   1. exact `clientId` match against CLIENT_BY_ID
 *   2. exact name match (case-insensitive)
 *   3. fuzzy name match (one includes the other)
 *
 * Returns `null` when no match exists.
 *
 * 03/06/2026 — Extracted from 3 duplicated helpers in
 * CorkBoardContracts / AvailableContracts / ActiveContractsList.
 */
export function resolveClient(payload) {
  if (!payload) return null;
  if (payload.clientId && CLIENT_BY_ID[payload.clientId]) return CLIENT_BY_ID[payload.clientId];
  const name = payload.clientName || payload.senderName;
  if (name) {
    const lower = name.toLowerCase();
    return RECURRENT_CLIENTS.find(x => x.name.toLowerCase() === lower)
        || RECURRENT_CLIENTS.find(x => lower.includes(x.name.toLowerCase()))
        || RECURRENT_CLIENTS.find(x => x.name.toLowerCase().includes(lower))
        || null;
  }
  return null;
}
